/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApplicationTypeDetails,
    ApplicationTypeDetailsFromJSON,
    ApplicationTypeDetailsFromJSONTyped,
    ApplicationTypeDetailsToJSON,
    BookingTolerancesAggregatorProviderMap,
    BookingTolerancesAggregatorProviderMapFromJSON,
    BookingTolerancesAggregatorProviderMapFromJSONTyped,
    BookingTolerancesAggregatorProviderMapToJSON,
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface BookingTolerancesFormConfiguration
 */
export interface BookingTolerancesFormConfiguration {
    /**
     * 
     * @type {Array<ApplicationTypeDetails>}
     * @memberof BookingTolerancesFormConfiguration
     */
    applicationTypes?: Array<ApplicationTypeDetails> | null;
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof BookingTolerancesFormConfiguration
     */
    readonly brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof BookingTolerancesFormConfiguration
     */
    readonly distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof BookingTolerancesFormConfiguration
     */
    readonly relevances?: Array<number> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof BookingTolerancesFormConfiguration
     */
    readonly suppliers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<BookingTolerancesAggregatorProviderMap>}
     * @memberof BookingTolerancesFormConfiguration
     */
    readonly aggregatorProviderMaps?: Array<BookingTolerancesAggregatorProviderMap> | null;
}

export function BookingTolerancesFormConfigurationFromJSON(json: any): BookingTolerancesFormConfiguration {
    return BookingTolerancesFormConfigurationFromJSONTyped(json, false);
}

export function BookingTolerancesFormConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingTolerancesFormConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'applicationTypes': !exists(json, 'applicationTypes') ? undefined : (json['applicationTypes'] === null ? null : (json['applicationTypes'] as Array<any>).map(ApplicationTypeDetailsFromJSON)),
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'relevances': !exists(json, 'relevances') ? undefined : json['relevances'],
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'aggregatorProviderMaps': !exists(json, 'aggregatorProviderMaps') ? undefined : (json['aggregatorProviderMaps'] === null ? null : (json['aggregatorProviderMaps'] as Array<any>).map(BookingTolerancesAggregatorProviderMapFromJSON)),
    };
}

export function BookingTolerancesFormConfigurationToJSON(value?: BookingTolerancesFormConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'applicationTypes': value.applicationTypes === undefined ? undefined : (value.applicationTypes === null ? null : (value.applicationTypes as Array<any>).map(ApplicationTypeDetailsToJSON)),
    };
}


